export default {
  search: (term) => `profile/search?term=${term}`,
  show: (profileID) => `/profile/search/show/${profileID}`,
  stats: `/profile/search/stats`,
};
